export default function AdminPageList({ heading, listitem }) {
  return (
    <div className="flex gap-3 flex-wrap">
      <div className="bg-[#015A52] text-white p-2 text-base sm:text-xl rounded-xl h-fit ">
        {heading}
      </div>
      <div className="flex flex-col gap-2">
        <div className="bg-[#F1F1F1] p-2 rounded-lg">{listitem}</div>
        <div className="bg-[#F1F1F1] p-2 rounded-lg">{listitem}</div>
        <div className="bg-[#F1F1F1] p-2 rounded-lg">{listitem}</div>
      </div>
    </div>
  );
}
